import { ErrorHandler, Injectable } from '@angular/core';

import { FuncionesService } from '../funciones.service';
import { HttpErrorResponse } from '@angular/common/http'
import { SweetAlertIcon } from 'sweetalert2';
import { UiService } from '../ui/ui.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {

  ui = new UiService();

  constructor( private readonly funSrv: FuncionesService ) { }

  handleError(error: any): void {

    if( error instanceof Error ) {
      return;
    }
    else if( error instanceof HttpErrorResponse && error.status != 200) {
      this.ui.hiddeLoading();
      let title = "Oops, ha ocurrido un error.";
      let icon:SweetAlertIcon = 'error';
      let mensaje =  (error?.error?.mensaje ?? error?.error?.message) ?? this.funSrv.validarErrorSesion( error )
      this.ui.showAlert( title, mensaje, icon );
      return;
    }

    this.ui.hiddeLoading();
    let title = (error.title) ? error.title : "Ooops, ha ocurrido un error.";
    let icon:SweetAlertIcon = (error.icon) ? error.icon : 'error';
    this.ui.showAlert( title, error.message, icon );
  }
}
